enum Column {
  Status = 'status',
  Name = 'name',
  NameNotClickable = 'nameNotClickable',
  Stage = 'Stage',
  Permissions = 'permissions',
  Users = 'users',
  Files = 'files',
  Size = 'size',
  EmailAlerts = 'emailAlerts',
  Approved = 'approved',
  LastActivity = 'lastActivity',
  LastActivityExploreSets = 'lastActivityExploreSets',
  LastActivityExploreSetsWithSessionCheck = 'lastActivityExploreSetsWithSessionCheck',
  LastActivityExploreSetsWithCountryCheckCallback = 'lastActivityExploreSetsWithCountryCheckCallback',
  Sector = 'sector',
  Sponsor = 'sponsor',
  Underwriter = 'underwriter',
  StepsToComplete = 'stepsToComplete',
  Bank = 'bank',
  Declaration = 'declaration',
  TransactionType = 'transactionType',
  ArrangerAgent = 'arrangerAgent',
}

export default Column;
